/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget Multi Balances Reducer
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    WIDGET_MULTI_BALANCES_GET_LIST_FAILURE,
    WIDGET_MULTI_BALANCES_GET_LIST_START,
    WIDGET_MULTI_BALANCES_GET_LIST_SUCCESS,
} from './widgetMultiBalancesConstants';
import { IWidgetMultiBalancesReducer, TWidgetMultiBalancesActions } from './widgetMultiBalancesTypes';

export const widgetMultiBalancesInitialState: IWidgetMultiBalancesReducer = {
    error: '',
    list: [],
};

const widgetMultiBalancesReducer: Reducer<IWidgetMultiBalancesReducer, TWidgetMultiBalancesActions> =
    (state = widgetMultiBalancesInitialState, action: TWidgetMultiBalancesActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIDGET_MULTI_BALANCES_GET_LIST_START:
                    draft.error = '';
                    break;
                case WIDGET_MULTI_BALANCES_GET_LIST_SUCCESS:
                    draft.list = action.payload.list;
                    break;
                case WIDGET_MULTI_BALANCES_GET_LIST_FAILURE:
                    draft.error = action.payload;
                    break;
            }
        });

export default widgetMultiBalancesReducer;
